export const sanitizeProgress = (progress: number) => {
    return progress.toFixed(0);
}